import React from 'react';
import './LoadingSpinner.css';

/**
 * Reusable loading spinner component
 * @param {string} size - Size of spinner: 'sm', 'md', 'lg' (default: 'md')
 * @param {string} color - Color of spinner (default: primary color)
 * @param {string} text - Optional loading text to display
 * @param {boolean} fullScreen - Whether to display as full screen overlay
 * @param {string} className - Additional CSS classes
 */
function LoadingSpinner({
  size = 'md',
  color,
  text,
  fullScreen = false,
  className = ''
}) {
  const spinnerClasses = `loading-spinner loading-spinner--${size} ${className}`;
  const spinnerStyle = color ? { borderTopColor: color, borderRightColor: color } : {};

  const spinner = (
    <div className={spinnerClasses}>
      <div className="loading-spinner__circle" style={spinnerStyle} />
      {text && <p className="loading-spinner__text">{text}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loading-spinner__overlay">
        {spinner}
      </div>
    );
  }

  return spinner;
}

export default LoadingSpinner;
